

// import { styled, alpha } from '@mui/material';
// import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';

// export interface CustomPickerDayProps extends PickersDayProps {
//   dayIsBetween?: boolean;
//   isFirstDay?: boolean;
//   isLastDay?: boolean;
// }

// export const CustomPickersDay = styled(PickersDay, {
//   shouldForwardProp: (prop) => prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay',
// })<CustomPickerDayProps>(({ theme, dayIsBetween, isFirstDay, isLastDay }) => ({
//   // ✅ --- STABLE GRID WITH BOX-SHADOW ---
//   // This creates a 1px border inside the element without affecting layout.
//   // This prevents the "scrunching" effect because every cell has the exact same size.
//   boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`,
//   borderRadius: 0,
  
//   // --- HIGHLIGHT STYLES ---
//   // The highlight styles are now simpler, as they don't need to modify the border or margin.
//   ...(dayIsBetween && {
//     borderRadius: 0,
//     backgroundColor: alpha("#0064FF", 0.1),
//     color: theme.palette.text.primary,
//     '&:hover, &:focus': {
//       backgroundColor: alpha("#0064FF", 0.2),
//     },
//   }),
  
//   // Apply rounded corners to the start and end of the range.
//   ...(isFirstDay && { borderTopLeftRadius: '50%', borderBottomLeftRadius: '50%' }),
//   ...(isLastDay && { borderTopRightRadius: '50%', borderBottomRightRadius: '50%' }),

//   // UNIFIED STYLE FOR THE START & END DATES
//   ...((isFirstDay || isLastDay) && {
//     backgroundColor: "#0064FF",
//     color: theme.palette.common.white,
//     '&:hover, &:focus': {
//       backgroundColor: "#0052cc",
//     },
//   }),
  
//   // Remove the default "today" highlight.
//   '&.MuiPickersDay-today': {
//     boxShadow: `inset 0 0 0 1px ${theme.palette.primary.main}`, // Give today a subtle blue outline instead of none
//   },
// }));

import { styled, alpha } from '@mui/material';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';

export interface CustomPickerDayProps extends PickersDayProps {
  dayIsBetween?: boolean;
  isFirstDay?: boolean;
  isLastDay?: boolean;
}

export const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay',
})<CustomPickerDayProps>(({ theme, dayIsBetween, isFirstDay, isLastDay }) => ({
  // ✅ --- STABLE GRID LOGIC ---
  // 1. Force ALL days to have no border to prevent the "today" button from having a different size.
  border: 0,
  
  // 2. Use inset box-shadow for the grid. This does NOT affect layout size.
  boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`,
  borderRadius: 0,
  
  // --- HIGHLIGHT STYLES ---
  ...(dayIsBetween && {
    borderRadius: 0,
    backgroundColor: alpha("#0064FF", 0.1),
    color: theme.palette.text.primary,
    boxShadow: 'none', // Remove inner grid line for a seamless highlight
    '&:hover, &:focus': {
      backgroundColor: alpha("#0064FF", 0.2),
    },
  }),
  
  // Apply rounded corners to the start and end of the range.
  ...(isFirstDay && { borderTopLeftRadius: '50%', borderBottomLeftRadius: '50%' }),
  ...(isLastDay && { borderTopRightRadius: '50%', borderBottomRightRadius: '50%' }),

  // UNIFIED STYLE FOR THE START & END DATES
  ...((isFirstDay || isLastDay) && {
    backgroundColor: "#0064FF",
    color: theme.palette.common.white,
    boxShadow: 'none', // Remove inner grid line for a seamless highlight
    '&:hover, &:focus': {
      backgroundColor: "#0052cc",
    },
  }),
  
  // Override the default "today" style to ensure it has no border.
  '&.MuiPickersDay-today': {
    border: 0,
  },
}));